import {
  CASH_MOVEMENT_CATEGORY_LABELS,
  isCashMovementCategory,
} from '../../cash/domain-api';
import type { ExpenseSettlementMethod } from '../../expenses/domain/expenseTypes';

const SETTLEMENT_METHOD_LABELS: Record<ExpenseSettlementMethod, string> = {
  cash_drawer: 'Efectivo de caja',
  transfer: 'Transferencia',
  card: 'Tarjeta',
  check: 'Cheque',
  other: 'Otro',
};

const EXTRA_COLLECTION_METHOD_LABELS: Record<string, string> = {
  customer_payment: 'Cobros a clientes',
  cash_inflow_manual: 'Ingreso manual en caja',
};

export function treasuryCollectionMethodLabel(
  methodId: string,
  paymentMethodNames?: Record<string, string>
): string {
  if (EXTRA_COLLECTION_METHOD_LABELS[methodId]) {
    return EXTRA_COLLECTION_METHOD_LABELS[methodId];
  }
  return paymentMethodNames?.[methodId] ?? methodId;
}

export function treasuryCashOutflowCategoryLabel(category: string): string {
  if (isCashMovementCategory(category)) {
    return CASH_MOVEMENT_CATEGORY_LABELS[category];
  }
  return category;
}

export function treasurySettlementMethodLabel(method: ExpenseSettlementMethod): string {
  return SETTLEMENT_METHOD_LABELS[method] ?? method;
}

export const TREASURY_DISCLAIMER_LINES = [
  'Es la plata que entró y salió en el período que elegiste.',
  'No es el margen de productos ni el resultado neto de rentabilidad.',
  'No es lo que marca el banco: acá no entran deudas impagas como si ya las cobraras.',
  'Los cobros de ventas van con la fecha de la venta; los pagos de clientes y egresos de caja, con su fecha real.',
] as const;
